<div class="image-viewer-root layout fit center-center"
    [class.iv-justmoved]="justmoved"
    (mousemove)="moved()"
    (mousedown)="moved()"
    (scroll)="moved()"
    (mousewheel)="scroll($event)"
    (click)="overlayRef!.dispose()"
    #root>
    @if (err) {
        <div class="layout center-center bc" style="border: 1px solid">
            <div class="fs-m txt-err tac pv05">Не удалось загрузить изображение</div>
        </div>
    }
    @else if (_loading()) {
        <div class="layout center-center op05"><div class="loader"></div></div>
    }
    @else if (files) {
        @if (files[index]; as file) {
            @if (file.id; as fid) {
                <div cdkDrag [cdkDragFreeDragPosition]="pos" (cdkDragStarted)="dragged = true">
                    @if (videos[fid]) {
                        <video
                            controls
                            autoplay
                            disablepictureinpicture
                            class="iv-image"
                            [src]="videos[fid]"
                            [style.transform]="'rotate(' + rotate + 'deg) scale(' + scale + ')'"
                            (pinch)="onPinch($event)"
                            (click)="se($event)"
                            (dblclick)="scale == 1 ? scaleToFit(vid, root) : setScale(1)"
                            #vid>
                        </video>
                    }
                    @else {
                        <img class="iv-image"
                            [src]="images[fid]"
                            [style.transform]="'rotate(' + rotate + 'deg) scale(' + scale + ')'"
                            (load)="shrinkToFit(img, root)"
                            (pinch)="onPinch($event)"
                            (click)="se($event)"
                            (dblclick)="pos = { x: 0, y: 0 }; scale == 1 ? scaleToFit(img, root) : setScale(1)"
                            #img>
                    }
                </div>
            }
            <div class="iv-toolbar layout vertical center p05" style="bottom: 0">
                <b>
                    {{ file.name }}
                    | {{ file.metadata?.width || file.imgView?.width }}x{{ file.metadata?.height || file.imgView?.height }}
                    | {{ file.size | ksize:1:' ' }}
                </b>
                @if (file.description) {
                    <span>{{ file.description }}</span>
                }
            </div>
        }
        <div class="iv-toolbar layout center p05" style="right: 0">
            <i class="vz-btn-xl vzi-ch-right" style="font-size: 64px;" [class.disabled]="index >= files.length - 1" (click)="nextImage(); se($event);"></i>
        </div>
        <div class="iv-toolbar layout center p05" style="left: 0">
            <i class="vz-btn-xl vzi-ch-left" style="font-size: 64px;" [class.disabled]="index == 0" (click)="prevImage(); se($event);"></i>
        </div>
    }
    <div class="iv-toolbar layout center p05" style="top: 0; right: 0;">
        <span class="fs-l bc-ll ph1 mr05" style="border-right: 1px solid;">{{ trunc(scale * 100) }}%</span>
        @if (!_loading() && !err && (dragged || rotate != 0 || scale != 1)) {
            <i class="vz-btn vzi-block mr1 fs-3xl" (click)="reset(); se($event);"></i>
        }
        <i class="vz-btn vzi-zoom-out mr025" [class.disabled]="_loading() || err" (click)="zoom(-.25); se($event);"></i>
        <i class="vz-btn vzi-zoom-in mr1" [class.disabled]="_loading() || err" (click)="zoom(.25); se($event);"></i>
        <i class="vz-btn vzi-rotate-left fs-4xl mr025" [class.disabled]="_loading() || err" (click)="turn(-90); se($event);"></i>
        <i class="vz-btn vzi-rotate-right fs-4xl mr1" [class.disabled]="_loading() || err" (click)="turn(90); se($event);"></i>
        <i class="vz-btn vzi-cross fs-5xl top-2" (click)="overlayRef!.dispose(); se($event);"></i>
    </div>
</div>

@if (_error(); as err) {
    <vz-error-message [error]="err" (dismiss)="_error.set(undefined)" />
}
